var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C3.44772 21 3 20.5523 3 20L3 14C3 13.4477 3.44772 13 4 13L10 13C10.5523 13 11 13.4477 11 14L11 20C11 20.5523 10.5523 21 10 21L4 21ZM4 11C3.44772 11 3 10.5523 3 10L3 4C3 3.44772 3.44772 3 4 3L10 3C10.5523 3 11 3.44772 11 4L11 10C11 10.5523 10.5523 11 10 11L4 11ZM14 21C13.4477 21 13 20.5523 13 20L13 14C13 13.4477 13.4477 13 14 13L20 13C20.5523 13 21 13.4477 21 14L21 20C21 20.5523 20.5523 21 20 21L14 21ZM13.3 6C13.1343 6 13 6.13431 13 6.3L13 7.7C13 7.86569 13.1343 8 13.3 8L15.7 8C15.8657 8 16 8.13431 16 8.3L16 10.7C16 10.8657 16.1343 11 16.3 11L17.7 11C17.8657 11 18 10.8657 18 10.7L18 8.3C18 8.13431 18.1343 8 18.3 8L20.7 8C20.8657 8 21 7.86569 21 7.7L21 6.3C21 6.13431 20.8657 6 20.7 6L18.3 6C18.1343 6 18 5.86569 18 5.7L18 3.3C18 3.13431 17.8657 3 17.7 3L16.3 3C16.1343 3 16 3.13432 16 3.3L16 5.7C16 5.86569 15.8657 6 15.7 6L13.3 6Z",
    fill: "#3D1CAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateBoard);
export default __webpack_public_path__ + "static/media/CreateBoard.2dafdf60725e857fc98cdde27965a109.svg";
export { ForwardRef as ReactComponent };